import { URL } from "./URLVariables";


export const fetchData = (reqType, token, id) => {

    if (reqType === 'fieldnames') {
        return fetch(`${URL}/api/v1/field`, {
            headers: {
                'Authorization': `sessionid ${token}`,
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
        })
            .then(response => {
                if (response.ok) {
                    return response.json()
                } else if (response.status === 404) {
                    throw new Error('404 Page not found');
                } else {
                    throw new Error(`${response.status}`);
                }
            })
            .catch(error => {
                throw new Error(`: ${error.message}`);
            });
    } else if (reqType === 'singleField') {
        return fetch(`${URL}/api/v1/field/${id}`, {
            headers: {
                'Authorization': `sessionid ${token}`,
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
        })
            .then(response => {
                if (response.ok) {
                    return response.json()
                } else if (response.status === 404) {
                    throw new Error('404 Page not found');
                } else {
                    throw new Error(`${response.status}`);
                }
            })
            .catch(error => {
                throw new Error(`: ${error.message}`);
            });
    } else if (reqType === 'allZones') {
        return fetch(`${URL}/api/v1/zone`, {
            headers: {
                'Authorization': `sessionid ${token}`,
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
        })
            .then(response => {
                if (response.ok) {
                    return response.json()
                } else if (response.status === 404) {
                    throw new Error('404 Page not found');
                } else {
                    throw new Error(`${response.status}`);
                }
            })
            .catch(error => {
                throw new Error(`: ${error.message}`);
            });
    } else if (reqType === 'allPipes') {
        return fetch(`${URL}/api/v1/pipe`, {
            headers: {
                'Authorization': `sessionid ${token}`,
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
        })
            .then(response => {
                if (response.ok) {
                    return response.json()
                } else if (response.status === 404) {
                    throw new Error('404 Page not found');
                } else {
                    throw new Error(`${response.status}`);
                }
            })
            .catch(error => {
                throw new Error(`: ${error.message}`);
            });
    } else if (reqType === 'singleZone') {
        return fetch(`${URL}/api/v1/zone/${id}`, {
            headers: {
                'Authorization': `sessionid ${token}`,
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
        })
            .then(response => {
                if (response.ok) {
                    return response.json()
                } else if (response.status === 404) {
                    throw new Error('404 Page not found');
                } else {
                    throw new Error(`${response.status}`);
                }
            })
            .catch(error => {
                throw new Error(`: ${error.message}`);
            });
    }
}

export const postField = (fieldInfo, sessionToken) => {

    return fetch(`${URL}/api/v1/field`, {
        method: 'POST', 
        headers: {
            'Authorization': `sessionid ${sessionToken}`,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(fieldInfo),
    })
        .then(response => {
            if (response.ok) {
                return response.json()
            }else {
                throw new Error(`${response.status}`);
            }
        })
        .catch(error => {
            throw new Error(`: ${error.message}`);
        });

};

export const postPipe = (pipeInfo, token) => {

    return fetch(`${URL}/api/pipe`, {
        method: 'POST',
        headers: {
            'Authorization': `sessionid ${token}`,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(pipeInfo),
    })
        .then(response => {
            if (response.ok) {
                return response.json()
            } else {
                throw new Error(`${response.status}`);
            }
        })
        .catch(error => {
            throw new Error(`: ${error.message}`);
        });
}

export const postZone = (zoneInfo, token) => {

    return fetch(`${URL}/api/v1/zone`, {
        method: 'POST',
        headers: {
            'Authorization': `sessionid ${token}`,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(zoneInfo),
    })
        .then(response => {
            if (response.ok) {
                return response.json()
            } else {
                throw new Error(`${response.status}`);
            }
        })
        .catch(error => {
            throw new Error(`: ${error.message}`);
        });
}

export const postLogin = async (loginInfo) => {
    const response = await fetch(`${URL}/api/v1/login`, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(loginInfo),
    });
  
    const responseBody = await response.json(); // Parse the response body
  
    if (response.ok) {
      return responseBody;
    } else {
      throw responseBody; // Throw the response body as the error
    }
  };
  


export const postAccountCreation = (body) => {

    return fetch(`${URL}/api/v1/register`, {
        method: 'POST', 
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
    })
        .then(response => {
            console.log("API Endpoint",`${URL}/api/v1/register`)
            if (response.ok) {
                return response.json()
            }else {
                throw new Error(`${response.status}`);
            }
        })
        .catch(error => {
            throw new Error(`: ${error.message}`);
        });

};

export const fetchFctlHw = (token) => {

    return fetch(`${URL}/api/hardware/fctl`, {
        method: 'GET',
        headers: {
            'Authorization': `sessionid ${token}`,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
    })
        .then(response => {
            if (response.ok) {
                return response.json()
            } else {
                throw new Error(`${response.status}`);
            }
        })
        .catch(error => {
            throw new Error(`: ${error.message}`);
        });
}

export const postPipeSequence = (id, body, token) => {

   return fetch(`${URL}/api/v1/field/${id}/sequence`, {
       method: 'POST', 
       headers: {
           'Authorization': `sessionid ${token}`,
           'Accept': 'application/json',
           'Content-Type': 'application/json',
       },
       body: JSON.stringify(body),
   })
       .then(response => {
           if (response.ok) {
               return response.json();
           } else {
               throw new Error(`${response.status}`);
           }
       })
       .catch(error => {
           throw new Error(`: ${error.message}`);
       });
};

export const postPipePercentage = (gateId, percent, token) => {
    console.log("Percentage Request:", { gateId, percent });

    return fetch(`${URL}/api/v1/gate/${gateId}/percent`, {
        method: 'PUT',
        headers: {
            'Authorization': `sessionid ${token}`,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ percent }),
    })
    .then(response => {
        if (response.ok) {
            return response.json();
        } else {
            throw new Error(`${response.status}`);
        }
    })
    .catch(error => {
        throw new Error(`: ${error.message}`);
    });
};



export const postPipeState = (gateId, token) => {
    return fetch(`${URL}/api/v1/gate/${gateId}/toggle`, {
        method: 'PUT',
        headers: {
            'Authorization': `sessionid ${token}`,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        }
    })
    .then(response => {
        if (response.ok) {
            return response.json();
        } else {
            throw new Error(`${response.status}`);
        }
    })
    .catch(error => {
        throw new Error(`: ${error.message}`);
    });
};


export const fetchSinglePipe = ( id, token) => {
    
    return fetch(`${URL}/api/v1/pipe/${id}`, {
        method: 'GET',
        headers: {
            'Authorization': `sessionid ${token}`,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
    })
        .then(response => {
            if (response.ok) {
                return response.json()
            } else {
                throw new Error(`${response.status}`);
            }
        })
        .catch(error => {
            throw new Error(`: ${error.message}`);
        });
}

export const fetchHistory = (token) => {

    return fetch(`${URL}/api/logs`, {
        method: 'GET',
        headers: {
            'Authorization': `sessionid ${token}`,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
    })
        .then(response => {
            if (response.ok) {
                return response.json()
            } else {
                throw new Error(`${response.status}`);
            }
        })
        .catch(error => {
            throw new Error(`: ${error.message}`);
        });
}

export const appendZone = (body, token) => {
    return fetch(`${URL}/api/zone?pipemode=append`, {
        method: 'PUT', 
        headers: {
            'Authorization': `sessionid ${token}`,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
    })
    .then(response => {
        if (response.ok) {
            return response.json()
        } else {
            throw new Error(`${response.status}`);
        }
    })
    .catch(error => {
        throw new Error(`: ${error.message}`);
    });
}

export const toggleZone = ( token, id) => {
    return fetch(`${URL}/api/v1/zone/${id}/toggle`, {
        method: 'PUT', 
        headers: {
            'Authorization': `sessionid ${token}`,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
    })
    .then(response => {
        if (response.ok) {
            return response.json()
        } else {
            throw new Error(`${response.status}`);
        }
    })
    .catch(error => {
        throw new Error(`: ${error.message}`);
    });
}

export const postNewInvite = (token) => {
    return fetch(`${URL}/api/v1/group/newinvite`, {
        method: 'POST', 
        headers: {
            'Authorization': `sessionid ${token}`,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
        // body: JSON.stringify(body),
    })
    .then(response => {
        if (response.ok) {
            return response.json()
        } else {
            throw new Error(`${response.status}`);
        }
    })
    .catch(error => {
        throw new Error(`: ${error.message}`);
    });
}


export const fetchGroupInvites = (token) => {
    return fetch(`${URL}/api/v1/group/invites`, {
        method: 'GET',
        headers: {
            'Authorization': `sessionid ${token}`,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
    })
        .then(response => {
            if (response.ok) {
                return response.json()
            } else {
                throw new Error(`${response.status}`);
            }
        })
        .catch(error => {
            throw new Error(`: ${error.message}`);
        });
}

export const fetchAssociatedUsers = (token) => {
    return fetch(`${URL}/api/v1/group/user`, {
        method: 'GET',
        headers: {
            'Authorization': `sessionid ${token}`,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
    })
        .then(response => {
            if (response.ok) {
                return response.json()
            } else {
                throw new Error(`${response.status}`);
            }
        })
        .catch(error => {
            throw new Error(`: ${error.message}`);
        });
}

export const fetchCurrentUser = (username, token) => {
    return fetch(`${URL}/api/v1/group/user`, {
        method: 'GET',
        headers: {
            'Authorization': `sessionid ${token}`,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
    })
        .then(response => {
            if (response.ok) {
                return response.json()
            } else {
                throw new Error(`${response.status}`);
            }
        })
        .then(users => {
            const user = users.find(u => u.username === username);
            if (!user) throw new Error('User not found');
            return user;
        })
        .catch(error => {
            throw new Error(`: ${error.message}`);
        });
}

export const postSubUserCreation = (body) => {
    return fetch(`${URL}/api/v1/group/register`, {
        method: 'POST', 
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
    })
        .then(response => {
            console.log("API Endpoint",`${URL}/api/v1/register`)
            if (response.ok) {
                return response.json()
            }else {
                throw new Error(`${response.status}`);
            }
        })
        .catch(error => {
            throw new Error(`: ${error.message}`);
        });
}

export const postWaterSensor = (body, id, token) => {
    return fetch(`${URL}/api/v1/field/${id}/ws`, {
        method: 'POST', 
        headers: {
            'Authorization': `sessionid ${token}`,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
    })
        .then(response => {
            if (response.ok) {
                return response.json()
            }else {
                throw new Error(`${response.status}`);
            }
        })
        .catch(error => {
            throw new Error(`: ${error.message}`);
        });
}

export const fetchWaterSensor = (token, id) => {
    return fetch(`${URL}/api/v1/ws`, {
        method: 'GET',
        headers: {
            'Authorization': `sessionid ${token}`,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
    })
        .then(response => {
            if (response.ok) {
                return response.json()
            } else {
                throw new Error(`${response.status}`);
            }
        })
        .catch(error => {
            throw new Error(`: ${error.message}`);
        });
}

export const fetchSingleWaterSensor = (token, id) => {
    return fetch(`${URL}/api/v1/ws/${id}`, {
        method: 'GET',
        headers: {
            'Authorization': `sessionid ${token}`,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
    })
        .then(response => {
            if (response.ok) {
                return response.json()
            } else {
                throw new Error(`${response.status}`);
            }
        })
        .catch(error => {
            throw new Error(`: ${error.message}`);
        });
}

export const fetchZoneWaterSensor = (token, id) => {
    return fetch(`${URL}/api/v1/zone/${id}/ws`, {
        method: 'GET',
        headers: {
            'Authorization': `sessionid ${token}`,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
    })
        .then(response => {
            if (response.ok) {
                return response.json()
            } else {
                throw new Error(`${response.status}`);
            }
        })
        .catch(error => {
            throw new Error(`: ${error.message}`);
        });
}

export const fetchWsZoneAssociation = (token, id) => {
    return fetch(`${URL}/api/v1/ws/${id}/listbind`, {
        method: 'GET',
        headers: {
            'Authorization': `sessionid ${token}`,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
    })
        .then(response => {
            if (response.ok) {
                return response.json()
            } else {
                throw new Error(`${response.status}`);
            }
        })
        .catch(error => {
            throw new Error(`: ${error.message}`);
        });
}

export const fetchZoneWsAssociation = (token, id) => {
    return fetch(`${URL}/api/v1/zone/${id}/listbind`, {
        method: 'GET',
        headers: {
            'Authorization': `sessionid ${token}`,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
    })
        .then(response => {
            if (response.ok) {
                return response.json()
            } else {
                throw new Error(`${response.status}`);
            }
        })
        .catch(error => {
            throw new Error(`: ${error.message}`);
        });
}

